// src/pages/ShelfLifeEnhancers.js
import React from 'react';
import ProductCategoryTemplate from '../components/templet/ProductCategoryTemplate';
import image2 from '../assets/images/product/image-2.jpg';
import image3 from '../assets/images/product/image-3.jpg';
import image4 from '../assets/images/product/image-4.jpg';
import image5 from '../assets/images/product/image-5.jpg';
import image6 from '../assets/images/product/image-6.jpg';
import image7 from '../assets/images/product/image-7.jpg';
import image8 from '../assets/images/product/image-8.jpg';
import image9 from '../assets/images/product/image-9.jpg';
import shelf from '../assets/images/category/shelf-life.jpg';

const ShelfLifeEnhancers = () => {
  const products = [
    {
      name: "Enessa Cake Shelf-Life Enhancer",
      category: "PRESERVATIVE",
      description: "A natural-blend solution that extends cake freshness and quality significantly. Keeps your cakes moist, soft, and safe without harsh chemicals or artificial additives.",
      features: [
        "Extended shelf-life up to 2x longer without refrigeration",
        "Maintains moisture and softness throughout storage",
        "Inhibits mold growth naturally without harsh chemicals",
        "Clean-label compatible with natural formulations"
      ],
      image: "/assets/images/cake-shelf-life.jpg"
    },
    {
      name: "Bake Life Plus (Bread Preservative)",
      category: "BREAD PRESERVATIVE",
      description: "The Go-to solution for extending bread shelf-life. Bake Life Plus is trusted by bakers to maintain bread quality, softness, and freshness without compromising on taste or natural appeal.",
      features: [
        "Calcium Propionate base for proven mold inhibition",
        "Maintains bread softness and prevents staling",
        "Extends freshness up to 7-10 days at room temperature",
        "Safe, widely-approved preservative system"
      ],
      image: "/assets/images/bread-preservative.jpg"
    },
    {
      name: "Enessa Bake Safe",
      category: "PRESERVATIVE",
      description: "A cutting-edge mold inhibitor and shelf-life extender for all your baked products. Enessa Bake Safe combines multiple preservation mechanisms to ensure your products stay safe, fresh, and appealing longer.",
      features: [
        "Multi-mechanism preservation for superior protection",
        "Effective against mold, yeast, and bacterial spoilage",
        "Works across wide pH range for various baked goods",
        "Low dosage requirement for cost-effective solutions"
      ],
      image: "/assets/images/bake-safe.jpg"
    },
    {
      name: "Traditional Preservatives",
      category: "PRESERVATIVES",
      description: "Time-tested preservation solutions including Calcium Propionate and Potassium Sorbate. Reliable, cost-effective, and regulatory-approved options for standard preservation needs.",
      features: [
        "Calcium Propionate (E282) : Industry-standard bread preservative, proven effectiveness",
        "Potassium Sorbate (E202) : Effective against yeast and molds, ideal for cakes",
        "Sorbic Acid (E200) : Powerful mold inhibitor for various applications",
        "Sodium Benzoate: Cost-effective preservative for acidic products"
      ],
      image: "/assets/images/traditional-preservatives.jpg"
    }
  ];

  const relatedCategories = [
    {
      title: "Bread Improvers & Dough Conditioners",
      description: "Boost volume, improve texture, extend shelf-life.",
      itemCount: 12,
      image: image2,
      link: "/products/bread-improvers"
    },
    {
      title: "Premixes & Concentrates",
      description: "Simplify your process with consistent results.",
      itemCount: 14,
      image: image3,
      link: "/products/premixes"
    },
    {
      title: "Emulsifiers & Texture Improvers",
      description: "Smoother texture and softer crumbs.",
      itemCount: 8,
      image: image4,
      link: "/products/emulsifiers"
    },
    {
      title: "Leavening Agents (Raising Agents)",
      description: "Perfect volume and texture every time.",
      itemCount: 13,
      image: image5,
      link: "/products/leavening"
    },
    {
      title: "Specialty Enzymes",
      description: "Transform dough quality naturally.",
      itemCount: 17,
      image: image6,
      link: "/products/enzymes"
    },
    {
      title: "Other Ingredients: Starches, Gums, Flavors",
      description: "Functional bakery ingredients.",
      itemCount: 20,
      image: image7,
      link: "/products/other-ingredients"
    },
    {
      title: "Quality Assurance",
      description: "Consistent Quality. Guaranteed.",
      itemCount: null,
      image: image8,
      link: "/quality"
    },
    {
      title: "View All",
      description: "Explore our complete range.",
      itemCount: null,
      image: image9,
      link: "/products"
    }
  ];

  return (
    <ProductCategoryTemplate
      title="Shelf-Life Enhancers & Preservatives"
      description="Keep your baked goods fresher, safer, and quality-assured for longer. Our advanced preservation solutions help you extend shelf-life while maintaining the authentic taste and texture your customers expect."
      heroImage={shelf}
      products={products}
      relatedCategories={relatedCategories}
    />
  );
};

export default ShelfLifeEnhancers;